import { GET_SHORTLIST_MANAGERS_DATA_LIST,GET_SHORTLIST_MANAGERS_DATA_LIST_SUCCESS,GET_SHORTLIST_MANAGERS_DATA_LIST_FAILED,GET_INTERVIEWERS_LIST, GET_INTERVIEWERS_LIST_SUCCESS, GET_INTERVIEWERS_LIST_FAILED } from "./actionTypes";
  
  const initialState = {
    managersLoader: false,
   shortlistMangersList:null,
   shortListMangersListError:null,
   interviewersList:null,
   interviewersListError:null,


  }
  
  const managersReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_SHORTLIST_MANAGERS_DATA_LIST:
        state = {
          ...state,
          managersLoader:true,
   shortlistMangersList:null,
   shortListMangersListError:null,
        }
        break
      case GET_SHORTLIST_MANAGERS_DATA_LIST_SUCCESS:
        state = {
          ...state,
          managersLoader:false,
   shortlistMangersList:action.payload,
   shortListMangersListError:null,
        }
        break
      case GET_SHORTLIST_MANAGERS_DATA_LIST_FAILED:
       
        state = {
          ...state,
          managersLoader:false,
   shortlistMangersList:null,
   shortListMangersListError:action.payload,
        }
        break
        case GET_INTERVIEWERS_LIST:
          state = {
            ...state,
            managersLoader: true,
            interviewersList:null,
   interviewersListError:null,
          }
          break
        case GET_INTERVIEWERS_LIST_SUCCESS:
          state = {
            ...state,
            managersLoader: false,
            interviewersList:action.payload,
   interviewresListError:null,
          }
          break
        case GET_INTERVIEWERS_LIST_FAILED:
         
          state = {
            ...state,
            managersLoader: false,
            interviewersList:null,
   interviewersListError:action.payload,
          }
          break
  
       
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default managersReducer
  